define(['text!./templates/basler-matriculation-number-help.html'],
    (templateStr) => {

        return ['ModalService',
            function (ModalService) { //NOSONAR
                return {
                    restrict: 'E',
                    template: templateStr,
                    scope: {},
                    link: function ($scope) { // NOSONAR

                        $scope.openDialog = function () {
                            ModalService.showSimpleDialog(`
                                <div class="infotext matriculation-number-help-modal-container">
                                    <div
                                        class="form-close matriculation-number-close"
                                        ng-click="$dismiss()"
                                        ng-include="'/qnb/styles/images/common/i_close.svg'"
                                    ></div>
                                    <div class="matriculation-number-help-modal-image-container">
                                        <img 
                                            srcset="/qnb/styles/images/common/matriculation_number_help_high.jpg 1024w,
                                            /qnb/styles/images/common/matriculation_number_help_mid.jpg 640w"                                                 
                                            src="/qnb/styles/images/common/matriculation_number_help_mid.jpg"
                                            alt="{{'quoteandbind.views.mfp-summary.matriculation-number-help.image-alt-text' | translate }}"
                                        >
                                    </div>
                                </div>
                            `);
                        };
                    },
                };
            },
        ];
    }
);



// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerMatriculationNumberHelp.js